/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import { register } from '../core/_requests'
import { Link } from 'react-router-dom'
import { KTIcon, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { PasswordMeterComponent } from '../../../../_metronic/assets/ts/components'

const initialValues = {
  first_name: '', // Thomas
  last_name: '', // Gärtner
  email: '', // gartner@kevinbrumme.de
  password: '',
  acceptTerms: false,
}

const registrationSchema = Yup.object().shape({
  first_name: Yup.string()
    .min(1, 'Minimum 1 Zeichen')
    .max(50, 'Maximum 50 Zeichen')
    .required('Pflichtfeld'),
  last_name: Yup.string()
    .min(1, 'Minimum 1 Zeichen')
    .max(50, 'Maximum 50 Zeichen')
    .required('Pflichtfeld'),
  email: Yup.string()
    .matches(
      // eslint-disable-next-line
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Bitte geben Sie eine E-Mail-Adresse im richtigen Format ein'
    )
    .required('Pflichtfeld'),
  password: Yup.string()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      'Verwenden Sie 8 oder mehr Zeichen mit einem Mix aus Buchstaben, Zahlen & Zeichen.'
    )
    .required('Verwenden Sie 8 oder mehr Zeichen mit einem Mix aus Buchstaben, Zahlen & Zeichen.'),
  acceptTerms: Yup.bool().required('Pflichtfeld'),
})

export function Registration() {
  const [loading, setLoading] = useState(false)
  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      try {
        const data = register(
          values.first_name,
          values.last_name,
          values.email,
          values.password,
        )

        console.log(data);
        // const { data: userData } = await getUserById('asdasdsasd')
        // setCurrentUser(userData as UserModel | undefined)
      } catch (error) {
        console.error(error)
        setStatus('The registration details is incorrect')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  useEffect(() => {
    PasswordMeterComponent.bootstrap()
  }, [])

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_signup_form'
      onSubmit={formik.handleSubmit}
    >
      {/* begin::Heading */}
      <div className='text-left mt-lg-8 mt-xl-12 mb-8'>
        <img
          alt='Logo'
          className='h-40px logo theme-light-show mb-3 me-4'
          src={toAbsoluteUrl('/media/logos/favicon_partnerportal.png')}
        />
        <img
          alt='Logo'
          className='h-55px logo theme-light-show'
          src={toAbsoluteUrl('/media/logos/ofindo_logo_partnerportal.svg')}
        />
        <img
          alt='Logo'
          className='h-40px logo theme-dark-show mb-3 me-4'
          src={toAbsoluteUrl('/media/logos/favicon_partnerportal.png')}
        />
        <img
          alt='Logo'
          className='h-55px logo theme-dark-show'
          src={toAbsoluteUrl('/media/logos/ofindo_logo_partnerportal.svg')}
        />
      </div>

      <div className='mb-8'>
        {/* begin::Title */}
        <h1 className='text-dark fw-bolder mb-0'>Kostenlos Registrieren</h1>
        {/* end::Title */}

        <div className='text-gray-500 fw-semibold fs-6'>
          Sie haben bereits ein Konto? {' '}
          <Link to='/auth/login'>
            Hier anmelden
          </Link>
        </div>
      </div>
      {/* end::Heading */}

      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}


      <div className='fv-row'>
        <div className='row'>
          <div className='col-lg-4'>
            <input
              type='radio'
              className='btn-check'
              name='partnerType'
              value='business'
              id='kt_create_account_form_account_type_business'
            />
            <label
              className='btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center mb-10'
              htmlFor='kt_create_account_form_account_type_business'
            >
              <KTIcon iconName='address-book' className='fs-3x me-5' />

              <span className='d-block fw-bold text-start'>
                <span className='text-dark fw-bolder d-block fs-4 mb-2'>Unternehmen / Selbständig</span>
              </span>
            </label>
          </div>

          <div className='col-lg-4'>
            <input
              type='radio'
              className='btn-check'
              name='partnerType'
              value='organization'
              id='kt_create_account_form_account_type_organization'
            />
            <label
              className='btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center'
              htmlFor='kt_create_account_form_account_type_organization'
            >
              <KTIcon iconName='briefcase' className='fs-3x me-5' />

              <span className='d-block fw-bold text-start'>
                <span className='text-dark fw-bolder d-block fs-4 mb-2'>Verein / Organisation</span>
              </span>
            </label>
          </div>

          <div className='col-lg-4'>
            <input
              type='radio'
              className='btn-check'
              name='partnerType'
              value='government'
              id='kt_create_account_form_account_type_government'

            />
            <label
              className='btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center'
              htmlFor='kt_create_account_form_account_type_government'
            >
              <KTIcon iconName='briefcase' className='fs-3x me-5' />
              <span className='d-block fw-bold text-start'>
                <span className='text-dark fw-bolder d-block fs-4 mb-2'>Staatliche Einrichtung</span>
              </span>
            </label>
          </div>

          <div className='text-danger mt-2'>
            <div className='accountType' />
          </div>
        </div>
      </div>

      Eingetragener Name der Gesellschaft
      {/* begin::Form group first_name */}
      <div className='fv-row mb-3'>
        <label className='form-label fw-bolder text-dark fs-6'>Vorname</label>
        <input
          type='text'
          {...formik.getFieldProps('first_name')}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.first_name && formik.errors.first_name,
            },
            {
              'is-valid': formik.touched.first_name && !formik.errors.first_name,
            }
          )}
        />
        {formik.touched.first_name && formik.errors.first_name && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block small'>
              <span role='alert'>{formik.errors.first_name}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}
      <div className='fv-row mb-3'>
        {/* begin::Form group last_name */}
        <label className='form-label fw-bolder text-dark fs-6'>Nachname</label>
        <input
          type='text'
          {...formik.getFieldProps('last_name')}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.last_name && formik.errors.last_name,
            },
            {
              'is-valid': formik.touched.last_name && !formik.errors.last_name,
            }
          )}
        />
        {formik.touched.last_name && formik.errors.last_name && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block small'>
              <span role='alert'>{formik.errors.last_name}</span>
            </div>
          </div>
        )}
        {/* end::Form group */}
      </div>

      {/* begin::Form group Email */}
      <div className='fv-row mb-3'>
        <label className='form-label fw-bolder text-dark fs-6'>E-Mail-Adresse</label>
        <input
          type='email'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent',
            { 'is-invalid': formik.touched.email && formik.errors.email },
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block small'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group Password */}
      <div className='fv-row mb-3' data-kt-password-meter='true'>
        <div className='mb-1'>
          <label className='form-label fw-bolder text-dark fs-6'>Passwort</label>
          <div className='position-relative mb-3'>
            <input
              type='password'
              autoComplete='off'
              {...formik.getFieldProps('password')}
              className={clsx(
                'form-control bg-transparent',
                {
                  'is-invalid': formik.touched.password && formik.errors.password,
                },
                {
                  'is-valid': formik.touched.password && !formik.errors.password,
                }
              )}
            />

          </div>
          {/* begin::Meter */}
          <div
            className='d-flex align-items-center mb-3'
            data-kt-password-meter-control='highlight'
          >
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
          </div>
          {/* end::Meter */}
        </div>
        {formik.touched.password && formik.errors.password ? (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block small'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        ) : (
          <div className='text-muted small'>
            Verwenden Sie 8 oder mehr Zeichen mit einem Mix aus Buchstaben, Zahlen & Zeichen.
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row my-8'>
        <label className='form-check form-check-inline' htmlFor='kt_login_toc_agree'>
          <input
            className='form-check-input'
            type='checkbox'
            id='kt_login_toc_agree'
            {...formik.getFieldProps('acceptTerms')}
          />
          <span>
            Ich bestätige, die <a
              href='https://partner.ofindo.de/agb/'
              target='_blank'
              className='link-primary'
            >Allgemeinen Geschäftsbedingungen
            </a> sowie die <a
              href='https://www.ofindo.de/datenschutz/?plattform=partner'
              target='_blank'
              className='link-primary'
            >Datenschutzerklärung
            </a> gelesen zu haben und akzeptiere diese.
          </span>
        </label>
        {formik.touched.acceptTerms && formik.errors.acceptTerms && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.acceptTerms}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_up_submit'
          className='btn btn-lg btn-primary w-100'
          disabled={formik.isSubmitting || !formik.isValid || !formik.values.acceptTerms}
        >
          {!loading && <span className='indicator-label'>Registrieren</span>}
          {loading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Wird geladen...{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>

        <div className='separator separator-content my-10'>
          <span className='w-50px text-gray-500 fw-semibold fs-7'>oder</span>
        </div>

        <Link to='/auth/login'>
          <button
            type='button'
            id='kt_login_signup_form_cancel_button'
            className='btn btn-lg btn-light-primary w-100'
          >
            Anmelden
          </button>
        </Link>
      </div>
      {/* end::Form group */}
    </form>
  )
}
